import { adminApiService } from './adminApiService';

export const WarehouseService = {
  // Get all warehouses
  getAllWarehouses: async (params = {}) => {
    const queryString = Object.keys(params).length ? 
      '?' + new URLSearchParams(params).toString() : '';
    return adminApiService.get(`/warehouses${queryString}`);
  },

  // Get active warehouses (public route for checkout)
  getActiveWarehouses: async () => {
    return adminApiService.get('/warehouses/active');
  },

  // Get warehouse by ID
  getWarehouseById: async (id) => {
    return adminApiService.get(`/warehouses/${id}`);
  },

  // Create warehouse
  createWarehouse: async (data) => {
    return adminApiService.post('/warehouses', data);
  },

  // Update warehouse
  updateWarehouse: async (id, data) => {
    return adminApiService.put(`/warehouses/${id}`, data);
  },

  // Delete warehouse
  deleteWarehouse: async (id) => {
    return adminApiService.delete(`/warehouses/${id}`);
  },

  // Toggle warehouse active status
  toggleWarehouseActive: async (id) => {
    return adminApiService.patch(`/warehouses/${id}/toggle-active`, {});
  },
};

export default WarehouseService;
